/**
 * NEXUMA — Shabllonet
 *
 * Faqja e vet e shablloneve. Vendi ku përdoruesi i gjen është tabi "Shabllonet"
 * te Konfigurimi (Company.js) — kjo faqe mbetet për lidhjet e vjetra
 * `?tab=shabllone-*`, që ridrejtohen këtu, dhe për lidhje të drejtpërdrejta.
 *
 * `?tab=` pranon slug-un (`kontratat`, `vendimet`, `verejtjet`), jo indeksin:
 * shtimi i një lloji të ri shabllonesh nuk duhet t'i thyejë lidhjet ekzistuese.
 * Të tri panelet vijnë nga `templateKinds.js`, i njëjti regjistër që ushqen
 * tabin te Konfigurimi — që të dyja anët të mos rrëshqasin nga njëra-tjetra.
 */
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import PageHeader from '../components/common/PageHeader';
import { TEMPLATE_KINDS, kindIndex } from '../components/templates/templateKinds';

export default function TemplatesPage() {
  const location = useLocation();
  const history  = useHistory();

  const active = kindIndex(new URLSearchParams(location.search).get('tab'));
  const Panel  = TEMPLATE_KINDS[active].Panel;

  const select = (i) => history.replace(`/templates?tab=${TEMPLATE_KINDS[i].key}`);

  return (
    <Box sx={{ minWidth: 0 }}>
      <PageHeader
        title="Shabllonet"
        subtitle="Tekstet e gatshme që përdoren kur lëshohet një kontratë, një vendim ose një vërejtje."
      />

      <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <Tabs
          value={active}
          onChange={(_, i) => select(i)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: '1px solid',
            borderColor: 'divider',
            minHeight: 42,
            '& .MuiTab-root': {
              textTransform: 'none', fontWeight: 600, fontSize: '0.8125rem',
              minHeight: 42, py: 0.75, gap: 0.75,
            },
          }}
        >
          {TEMPLATE_KINDS.map((k) => (
            <Tab key={k.key} icon={k.icon} iconPosition="start" label={k.label} />
          ))}
        </Tabs>

        <Box sx={{ p: { xs: 1, sm: 1.5 } }}>
          <Panel />
        </Box>
      </Paper>
    </Box>
  );
}
